module.exports = __webpack_public_path__ + "static/dining2-eef878254eca4b0f9157144c296af076.jpg";